module.exports = __webpack_public_path__ + "img/value.5abea8ff.png";